// src/AuthProvider.js
import React from 'react';
import AuthContextDefault, { AuthProvider as InnerAuthProvider } from './AuthContext';

// Re-exportera samma AuthContext så alla gamla imports funkar:
// import { AuthContext } from './AuthProvider'
export const AuthContext = AuthContextDefault;

// Default-exporten är fortfarande en komponent som heter AuthProvider
// så alla som gör import AuthProvider from './AuthProvider' funkar också.
export default function AuthProvider({ children }) {
  return <InnerAuthProvider>{children}</InnerAuthProvider>;
}
